import { appHttpService } from '@/services/standard/http-service';
import { models } from 'cesg-shared';

class LiftPlanService {
  async get(projectId: string): Promise<models.GetLiftPlanResponse> {
    return appHttpService.request
      .url(`/lift-plans/${projectId}`)
      .get()
      .json<models.GetLiftPlanResponse>();
  }

  async sync(projectId: string): Promise<void> {
    await appHttpService.request
      .url(`/lift-plans/${projectId}/setup`)
      .post()
      .res();
  }

  async put(
    projectId: string,
    body: models.PutLiftPlanBody,
  ): Promise<models.GetLiftPlanResponse> {
    return appHttpService.request
      .url(`/lift-plans/${projectId}`)
      .put(body)
      .json<models.GetLiftPlanResponse>();
  }
}

export const liftPlanService = new LiftPlanService();
